module.exports = __webpack_public_path__ + "img/finais.0e0b403f.png";